module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<cw-fieldset class="vueannuelle-calendrier">\r\n  <div class="phx-formTable">\r\n    <div class="tableCalendrier"></div>\r\n  </div>\r\n</fieldset>';
}
return __p;
};
